import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main
      className="min-h-screen pt-32 pb-24 flex items-center justify-center bg-[var(--c-bg)]"
      data-testid="not-found-page"
    >
      <div className="text-center max-w-md px-6">
        <p className="overline mb-4">Lost at Sea</p>
        <h1 className="font-serif-display text-6xl md:text-7xl text-[var(--c-text)]">
          404
        </h1>
        <p className="text-[var(--c-text-muted)] mt-4">
          That page is not part of this archive.
        </p>
        <Link
          to="/"
          className="inline-block mt-8 font-mono-plex text-xs uppercase tracking-[0.22em] text-[var(--c-bg)] bg-[var(--c-accent)] hover:bg-[var(--c-accent-bright)] px-6 py-3 transition-colors"
        >
          Return to Port
        </Link>
      </div>
    </main>
  );
}
